import { colors, flex, fonts } from '../../OpportunityWorkspace.style';

export const root = {
    ...flex.row,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: 12,
    columnGap: 16,
    boxSizing: 'border-box',
    width: '100%',
    padding: '8px 20px',
    marginBottom: 16,
    // backgroundColor: '#F8F9FC',
    border: `1px solid ${colors.contactSurfaceBorder}`,
    borderRadius: 8,
};

export const leftCluster = {
    ...flex.row,
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
};

export const personIcon = {
    fontSize: 22,
    color: colors.textSecondary,
    flexShrink: 0,
};

export const titleText = {
    fontFamily: fonts.sans,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.35,
    color: colors.textPrimaryDark,
};

export const searchWrap = {
    position: 'relative',
    flex: '1 1 auto',
    maxWidth: 280,
    minWidth: 160,
};

export const searchInput = {
    width: '100%',
    boxSizing: 'border-box',
    height: 36,
    padding: '0 40px 0 12px',
    fontFamily: fonts.sans,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.25,
    color: colors.textHeading,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: 6,
    outline: 'none',
};

export const searchIcon = {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 20,
    color: colors.textMuted,
    pointerEvents: 'none',
};
